module.exports = __webpack_public_path__ + "img/ai.7ec38889.png";